import * as React from 'react';

import ToastActions from 'actions/ToastActions';
// @ts-ignore
import { touch } from 'actions/touchActions';
import AvatarWithText from 'components/AvatarWithText';
import Button from 'components/Button';
import Buttons from 'components/Buttons';
import Input from 'components/Input';
import { TOUCH_KEY as NAV_TOUCH_KEY } from 'components/NavigationList/NavigationList';
import Row from 'components/Row';
import Text from 'components/Text';
import TextWithSubtext from 'components/TextWithSubtext';
import RemindAPI from 'lib/RemindAPI';

import { ChangeHandler } from 'types/typescript/eventHandlers';

import JOIN_GROUP_BY_CODE_MUTATION from './mutations/JoinGroupByCode.gql';

import './styles/JoinGroupModalRequestToJoin.scss';

type Props = {
  className: string;
  groupCode: string;
  schoolName: string | null;
  groupAvatar: React.ReactElement;
  onSubmit: () => void;
  onCancel: () => void;
};

type State = {
  message: string;
};

export default class JoinGroupModalRequestToJoin extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      message: '',
    };

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange = (event: React.FormEvent<HTMLInputElement>) => {
    this.setState({
      message: event.currentTarget.value,
    });
  };

  render() {
    const { groupAvatar, groupCode, className, schoolName } = this.props;
    const { message } = this.state;
    const subtextStr = schoolName ? `${groupCode} • ${schoolName}` : `${groupCode}`;

    return (
      <React.Fragment>
        <Text align="left" element="div">
          <Row>
            <div className="JoinGroupModalRequestToJoin-text">
              <AvatarWithText title={className} avatar={groupAvatar} subtext={subtextStr} />
            </div>
          </Row>

          <TextWithSubtext
            className="JoinGroupModalRequestToJoin-areaText"
            subtext="Let the class owner know who you are.">
            Include a message
          </TextWithSubtext>
        </Text>
        <Row>
          <Input type="text" onChange={this.handleChange} value={message} />
        </Row>
        <Buttons axis="y">
          <Button
            // TODO Styling and events
            // className="JoinGroupModal-done"
            // eventElementName="JoinGroupModal-done"
            onClick={event => {
              RemindAPI.execute({
                mutation: JOIN_GROUP_BY_CODE_MUTATION,
                variables: {
                  input: { groupCode, message },
                },
              })
                .then(() => {
                  ToastActions.showSuccessToast(
                    `You've submitted your request to join ${className}`
                  );
                  this.props.onSubmit();
                  // have the navbar update itself now so we can see the pending classes.
                  // tor note: do we want a different way to do this?
                  touch(NAV_TOUCH_KEY);
                })
                .catch((err: Error) => {
                  console.log('got error on RTJ join - ', err);
                  ToastActions.showErrorToast(
                    `We were unable to process your request to join ${className}, please try again later`
                  );
                });

              event.preventDefault();
            }}>
            Request to join class
          </Button>
          <Button
            level="secondary"
            // TODO Styling and events
            // className="JoinGroupModal-cancel"
            // eventElementName="JoinGroupModal-cancel"
            onClick={this.props.onCancel}>
            Cancel
          </Button>
        </Buttons>
      </React.Fragment>
    );
  }
}
